/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DarDto } from '../models/DarDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantDarControllerService {

    /**
     * Lists all configured dars of a participant
     * @param name
     * @param port
     * @returns DarDto OK
     * @throws ApiError
     */
    public static listParticipantDars(
        name: string,
        port: number = 5019,
    ): CancelablePromise<Array<DarDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants/{name}/dars',
            path: {
                'name': name,
            },
            query: {
                'port': port,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Upload dar file to a participant
     * @param name
     * @param darName
     * @param port
     * @returns any OK
     * @throws ApiError
     */
    public static uploadParticipantDar(
        name: string,
        darName: Array<string>,
        port: number = 5019,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participants/{name}/dars',
            path: {
                'name': name,
            },
            query: {
                'port': port,
                'darName': darName,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Remove a dar from a participant
     * @param name
     * @param darHash
     * @param port
     * @returns any OK
     * @throws ApiError
     */
    public static removeParticipantDar(
        name: string,
        darHash: string,
        port: number = 5019,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/participants/{name}/dars',
            path: {
                'name': name,
            },
            query: {
                'port': port,
                'darHash': darHash,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
